var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.consumedFreePeriod)?_c('div',[_c('div',[_c('livestream-gift')],1),_c('div',{staticClass:"mt-2"},[_c('livestream-comment')],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }